export default __webpack_public_path__ + "static/media/nft2.1ca82cea.jpeg";